/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offers_Section_TitleInputs */

const en_offers_section_title = /** @type {(inputs: Offers_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packs, plans and coaching`)
};

const pl_offers_section_title = /** @type {(inputs: Offers_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety, plany i prowadzenie`)
};

/**
* | output |
* | --- |
* | "Packs, plans and coaching" |
*
* @param {Offers_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_section_title = /** @type {((inputs?: Offers_Section_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Section_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_section_title(inputs)
	return en_offers_section_title(inputs)
});